export default __webpack_public_path__ + "static/media/img-0467-bulgaria-full-face.6df1fd45.png";